export interface Change {
  ticketId: string;
  ticketCreationDatetime: string;
  ticketClosureDatetime: string;
  changeStartDatetime: string;
  changeCloseDatetime: string;
  networkId: string | number | undefined;
  siteId: string | number | undefined;
  linkId: string | number | undefined;
  assetId: string | number | undefined;
  teamId: string | number | undefined;
  personId: string | number | undefined;
  communicationWithCustomer: string;
  imapctchangeStartDatetime: string;
  userid: any;
  ticketCreation: string;
  ticketClosure: string;
  summary: string;
  changeStart: string;
  changeClose: string;
  solution: string;
  affectedCustomer: string[];
  email: string;
  affectedNetwork: string[];
  affectedSite: string[];
  affectedLink: string[];
  affectedAntenna: string;
  asset: string[];
  errorType: string;
  closureCode: string;
  createdby: string;
  impact: string;
  urgency: string;
  priority: string;
  responsibleTeam: string;
  responsiblePerson: string;
  customerComplaint: boolean;
  customerInformed: boolean;
  status: string;
  journalUpdate: string;
  communication: string;
  sla: string;
  slaStatus: string;
  description: string;
  reactionPoint: string;
  responseTimeToOpen: string;
  customerapproval: boolean;
  responseTimeToClose: string;
  acceptanceTime: string;
  ola: string;
  olaStatus: string;
  acceptanceStatus: string;
  cabapproval: boolean;
  foruserid: number[];
  filePath: File[] | null;
  uploadPath: string;
  relatedobject: string[];
  impactchangeCloseDatetime: string;
  requiredresources: string[];
  rollbackstrategy: string;
  risk: string;
  changetemplate: string;
  typeofchange: string;
  phase: string;
  closedby: string;
}

export const initialChange: Change = {
  ticketId: "",
  userid: "",
  ticketCreation: "",
  ticketClosure: "",
  changeStart: "",
  changeClose: "",
  affectedCustomer: [],
  affectedNetwork: [],
  affectedSite: [],
  affectedLink: [],
  affectedAntenna: "",
  imapctchangeStartDatetime: "",
  asset: [],
  summary: "",
  description: "",
  errorType: "",
  createdby: "",
  closureCode: "",
  impact: "",
  urgency: "",
  priority: "",
  responsibleTeam: "",
  responsiblePerson: "",
  customerComplaint: false,
  customerInformed: false,
  email: "",
  status: "",
  journalUpdate: "",
  communication: "",
  sla: "",
  cabapproval: false,
  customerapproval: false,
  slaStatus: "",
  reactionPoint: "",
  responseTimeToOpen: "",
  solution: "",
  responseTimeToClose: "",
  acceptanceTime: "",
  ola: "",
  olaStatus: "",
  ticketCreationDatetime: "",
  ticketClosureDatetime: "",
  changeStartDatetime: "",
  changeCloseDatetime: "",
  networkId: undefined,
  siteId: undefined,
  linkId: undefined,
  assetId: undefined,
  teamId: undefined,
  personId: undefined,
  impactchangeCloseDatetime: "",
  communicationWithCustomer: "",
  acceptanceStatus: "",
  foruserid: [],
  filePath: [],
  uploadPath: "",
  relatedobject: [],
  requiredresources: [],
  rollbackstrategy: "",
  risk: "",
  typeofchange: "",
  changetemplate: "",
  phase: "",
  closedby: "",
};
